module.exports = __webpack_public_path__ + "static/media/verify-card.170458a3.svg";